import { AnalyticsRangePreset } from "../../enums";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ANALYTICS_FEATURE_KEY, AnalyticsSection, AnalyticsSections, AnalyticsState } from "./state";

export const selectAnalyticsState = createFeatureSelector<AnalyticsState>(ANALYTICS_FEATURE_KEY);

export const selectFilters = createSelector(selectAnalyticsState, state => state.filters);

export const selectSection = <K extends AnalyticsSection>(section: K, preset?: AnalyticsRangePreset) =>
  createSelector(selectAnalyticsState, (state): AnalyticsSections[K] => {
    const value = state[section];
    if ((preset || value.loadedPreset) && value.loadedPreset !== (preset ?? state.filters.preset)) {
      return { ...value, data: null, loading: !value.error };
    }
    return value;
  });

export const selectSectionData = <K extends AnalyticsSection>(section: K) =>
  createSelector(selectSection(section), (state): AnalyticsSections[K]["data"] => state.data);

export const selectSectionsLoading = (sections: AnalyticsSection[]) =>
  createSelector(selectAnalyticsState, state => sections.some(section => state[section].loading));

export const selectCampaignDetail = (campaignId: string) =>
  createSelector(selectAnalyticsState, state => state.campaignDetails[campaignId] ?? null);
